import { Container, Link, Typography, Card, CardContent, Box, Button, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CommonHelper } from 'src/utils/commonHelper';
import landingImage from '../assets/app-image/landing.png';
import useResponsive from '../hooks/useResponsive';
import { LoginForm } from '../sections/auth/login';
import { useTheme } from '@mui/material/styles';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const LoginPage = () => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const mdUp = useResponsive('up', 'md');
  const smDown = useResponsive('down', 'sm');

  const isBrand2ChatDomain = window.location.origin.includes('.brand2chat.ai');
  const navigate = useNavigate();
  const appLogo = CommonHelper.GetAppLogo(true);
  const navigateToRegister = () => {
    navigate('/register');
  };

  return (
    <>
      <Helmet>
        <title> {translate('login.login')} </title>
      </Helmet>
      <StyledRoot>
        {mdUp && (
          <Box
            sx={{
              flex: 1,
              minHeight: '100vh',
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 2%, #fff 100%)`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              position: 'relative',
            }}
          >
            <img src={appLogo} style={{ height: 48, marginBottom: 32 }} alt="logo" />
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
              {translate('login.welcome_back')}
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.85 }}>
              {translate('login.sign_in_to')} {CommonHelper.GetAppName()}
            </Typography>
            <img
              src={landingImage}
              alt="login"
              style={{ maxWidth: 320, borderRadius: 16, boxShadow: '0 8px 32px rgba(0,0,0,0.15)' }}
            />
          </Box>
        )}
        <Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', minHeight: '100vh' }}>
          <Box sx={{ width: '100%' }}>
            {smDown ? (
              <Box sx={{ p: 2 }}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <img src={appLogo} style={{ height: 32, marginBottom: 16 }} alt="logo" />
                  <Typography variant="h5" fontWeight={700} gutterBottom>
                    {translate('login.sign_in_to')} {CommonHelper.GetAppName()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {translate('login.welcome_back')}
                  </Typography>
                </Box>
                <Divider sx={{ mb: 3 }} />
                <LoginForm isBrand2ChatDomain={isBrand2ChatDomain} />
                <Divider sx={{ my: 3 }} />
                  <>
                    <Typography variant="body2" align="center">
                      {translate('login.dont_have_account')}?{' '}
                      <Link
                        onClick={navigateToRegister}
                        sx={{
                          color: 'primary.main',
                          fontWeight: 'bold',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }}
                      >
                        {translate('register.register_here')}
                      </Link>
                    </Typography>
                  </>
              </Box>
            ) : (
              <Card elevation={8} sx={{ borderRadius: 4, p: { xs: 2, sm: 4 } }}>
                <CardContent>
                  <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <img src={appLogo} style={{ height: 40, marginBottom: 16 }} alt="logo" />
                    <Typography variant="h4" fontWeight={700} gutterBottom>
                      {translate('login.sign_in_to')} {CommonHelper.GetAppName()}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {translate('login.welcome_back')}
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 3 }} />
                  <LoginForm isBrand2ChatDomain={isBrand2ChatDomain} />
                 
                    <>
                      <Divider sx={{ my: 3 }} />
                      <Typography variant="body2" align="center">
                        {translate('login.dont_have_account')}?{' '}
                        <Link
                          onClick={navigateToRegister}
                          sx={{
                            color: 'primary.main',
                            fontWeight: 'bold',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                        >
                          {translate('register.register_here')}
                        </Link>
                      </Typography>
                    </>
                  
                </CardContent>
              </Card>
            )}
          </Box>
        </Container>
      </StyledRoot>
    </>
  );
};
export default LoginPage;
